import React, { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import axios from "axios";
import { useNavigate } from "react-router-dom"; // Import useNavigate for redirecting
import "../components/AllBrand.css";
import Footer from "../components/Footer";
import apiClient from "../components/apiClient";
import Navbar from "../components/Navbar";

function AllBrand() {
  const [produk, setProduk] = useState([]);
  const { nama_brand } = useParams();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    const fetchProduk = async () => {
      try {
        setLoading(true);
        const produkResponse = await apiClient.get("/brand");
        setProduk(produkResponse.data);
      } catch (err) {
        setError("Gagal mengambil data Brands");
      } finally {
        setLoading(false);
      }
    };

    fetchProduk();
  }, []);

  // useEffect(() => {
  //   const fetchProduk = async () => {
  //     try {
  //       setLoading(true);
  //       const produkResponse = await apiClient.get(
  //         `/brand/getnama/${encodeURIComponent(nama_brand)}`
  //       );
  //       setProduk(produkResponse.data);
  //     } catch (err) {
  //       setError("Gagal mengambil data Brands");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchProduk();
  // }, [nama_brand]);

  // const sortedProduk = produk.sort((a, b) =>
  //   a.nama_brand.localeCompare(b.nama_brand, undefined, { sensitivity: "base" })
  // );

  // const handleImageClick = (id) => {
  const handleImageClick = (nama_brand, id) => {
    localStorage.setItem("brandId", id);
    localStorage.setItem("brandNama", nama_brand);
    // Navigate to the detail page
    navigate(`/all-brand/${nama_brand}`);
  };

  return (
    <>
      <Navbar />

      <div className="flex flex-col items-center justify-center text-center px-4 py-16 md:py-24">
        {loading && <p>Loading Brands...</p>}
        {error && <p>{error}</p>}

        <h5 className="mt-16 text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight">
          BRANDS
        </h5>

        {produk.length > 0 && (
          // <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 mt-8">
          <div className="w-full md:w-auto grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 md:gap-32 mt-8">
            {/* <div className="brand-grid"> */}
            {produk.map((item) => (
              <div
                key={item.id}
                className="brand-card h-20 md:h-full cursor-pointer md:bg-transparent"
                // onClick={() => handleImageClick(item.id)}
                onClick={() => handleImageClick(item.nama_brand, item.id)}
              >
                <img
                  src={item.image}
                  alt={item.nama_brand}
                  className="brand-image w-full h-48 object-cover md:scale-150"
                />
                {/* <p className="mt-2 text-lg font-medium">{item.nama_brand}</p> */}
              </div>
            ))}
          </div>
        )}
      </div>

      <Footer />
    </>
  );
}

export default AllBrand;
